import { ReactComponent as SpinnerSVG } from "./images/spinner.svg";

function Spinner() {
    return (
        <SpinnerSVG />
    )
}

export { Spinner };